import { RecoilRoot } from "recoil";

export default ({ children }) => <RecoilRoot>{children}</RecoilRoot>;
